import React from 'react';
import { Modal, Button, Spinner, Alert, Row, Col, Form } from 'react-bootstrap';

const CalibrationTableModal = ({
  show,
  onHide,
  loading,
  calibOsc,
  onOscChange,
  calibTable,
  onTableChange,
  onClear,
  onSave,
  hasChanges = true
}) => {
  const handleFieldChange = (idx, field, value) => {
    const newTable = [...calibTable];
    newTable[idx][field] = value;
    onTableChange(newTable);
  };

  const filledCount = calibTable.filter(r => r.caldial || r.calcapx || (r.chart && r.idx <= 4)).length;

  return (
    <Modal show={show} onHide={onHide} size="xl" centered>
      <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #1c4220 0%, #8fad15 100%)', border: 'none' }}>
        <Modal.Title style={{ color: 'white', fontWeight: 600 }}>📊 Tabelas de Calibração Completas</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ background: '#1e293b', color: '#e2e8f0' }}>
        <Alert variant="info" className="mb-3" style={{ background: 'rgba(59, 130, 246, 0.2)', border: '1px solid rgba(59, 130, 246, 0.3)', color: '#93c5fd' }}>
          <strong>ℹ️ Como usar:</strong> Preencha todos os campos desejados para a osciladora selecionada.
          Ao salvar, todos os valores serão enviados automaticamente. Deixe em branco os que não deseja alterar.
        </Alert>
        <Alert variant="secondary" style={{ background: 'rgba(100, 116, 139, 0.1)', border: '1px solid #475569', color: '#94a3b8', fontSize: '0.85em' }}>
          <strong>📡 Formato dos comandos enviados:</strong>
          <div style={{ fontFamily: 'monospace', marginTop: '8px', lineHeight: '1.8' }}>
            • <code style={{ background: 'rgba(0,0,0,0.3)', padding: '2px 6px', borderRadius: '3px' }}>CALDIAL1:posição:valor</code> → Ex: CALDIAL1:1:10.5<br />
            • <code style={{ background: 'rgba(0,0,0,0.3)', padding: '2px 6px', borderRadius: '3px' }}>CALCAPX1:posição:valor</code> → Ex: CALCAPX1:5:25.3<br />
            • <code style={{ background: 'rgba(0,0,0,0.3)', padding: '2px 6px', borderRadius: '3px' }}>CHART1:posição:valor</code> → Ex: CHART1:2:0.85 (apenas 1-4)
          </div>
          <details style={{ marginTop: '10px', cursor: 'pointer' }}>
            <summary style={{ color: '#60a5fa', fontWeight: 500 }}>Ver exemplo completo de calibração →</summary>
            <div style={{ marginTop: '10px', padding: '10px', background: 'rgba(0,0,0,0.3)', borderRadius: '5px', fontSize: '0.8em' }}>
              <strong>Sequência enviada para OSC1:</strong><br />
              <div style={{ color: '#4ade80', marginTop: '5px' }}>
                CALDIAL1:1:10.5 → CALDIAL1:2:15.0 → ... → CALDIAL1:10:55.5<br />
                CALCAPX1:1:25.3 → CALCAPX1:2:30.1 → ... → CALCAPX1:10:70.8<br />
                CHART1:1:0.000123 → CHART1:2:0.004567 → CHART1:3:-0.123456 → CHART1:4:12.345678
              </div>
              <small style={{ color: '#94a3b8', marginTop: '8px', display: 'block' }}>
                Total: 24 comandos (10 CALDIAL1 + 10 CALCAPX1 + 4 CHART1) com 200ms de intervalo = ~5 segundos
              </small>
            </div>
          </details>
        </Alert>
        <Row className="mb-3">
          <Col md={12}>
            <Form.Group>
              <Form.Label style={{ fontWeight: 600, color: '#cbd5e1' }}>Osciladora</Form.Label>
              <Form.Select
                value={calibOsc}
                onChange={e => onOscChange(e.target.value)}
                size="lg"
                style={{ background: '#334155', border: '1px solid #475569', color: '#e2e8f0' }}
              >
                <option value="1">📡 OSC1 (Principal)</option>
                <option value="2">📡 OSC2 (Secundário)</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        <div style={{ overflowX: 'auto' }}>
          <table className="table table-bordered table-sm" style={{ background: '#334155', borderColor: '#475569' }}>
            <thead style={{ background: '#1e293b', borderColor: '#475569' }}>
              <tr>
                <th style={{ width: 50, textAlign: 'center', color: '#cbd5e1', borderColor: '#475569' }}>#</th>
                <th style={{ minWidth: 150, borderColor: '#475569' }}>
                  <div style={{ fontWeight: 600, marginBottom: 4, color: '#cbd5e1' }}>CALDIAL</div>
                  <small className="text-muted" style={{ color: '#94a3b8' }}>Tabela Dial</small>
                </th>
                <th style={{ minWidth: 150, borderColor: '#475569' }}>
                  <div style={{ fontWeight: 600, marginBottom: 4, color: '#cbd5e1' }}>CALCAPX</div>
                  <small className="text-muted" style={{ color: '#94a3b8' }}>Capacitância</small>
                </th>
                <th style={{ minWidth: 150, borderColor: '#475569' }}>
                  <div style={{ fontWeight: 600, marginBottom: 4, color: '#cbd5e1' }}>CHART</div>
                  <small className="text-muted" style={{ color: '#94a3b8' }}>Curva Umidade (1-4)</small>
                </th>
              </tr>
            </thead>
            <tbody>
              {calibTable.map((row, idx) => (
                <tr key={idx}>
                  <td className="text-center" style={{ verticalAlign: 'middle', fontWeight: 600, color: '#cbd5e1', borderColor: '#475569' }}>{row.idx}</td>
                  <td style={{ borderColor: '#475569' }}>
                    <Form.Control
                      type="number"
                      step="any"
                      size="sm"
                      value={row.caldial}
                      onChange={e => handleFieldChange(idx, 'caldial', e.target.value)}
                      placeholder={`Ex: ${10 + idx * 5}`}
                      title={`Envia: CALDIAL${calibOsc === '2' ? '2' : ''}:${row.idx}:valor`}
                      style={{ background: '#1e293b', border: '1px solid #475569', color: '#e2e8f0' }}
                    />
                  </td>
                  <td style={{ borderColor: '#475569' }}>
                    <Form.Control
                      type="number"
                      step="any"
                      size="sm"
                      value={row.calcapx}
                      onChange={e => handleFieldChange(idx, 'calcapx', e.target.value)}
                      placeholder={`Ex: ${15 + idx * 3}`}
                      title={`Envia: CALCAPX${calibOsc === '2' ? '2' : ''}:${row.idx}:valor`}
                      style={{ background: '#1e293b', border: '1px solid #475569', color: '#e2e8f0' }}
                    />
                  </td>
                  <td style={{ borderColor: '#475569' }}>
                    {row.chart !== null ? (
                      <Form.Control
                        type="number"
                        step="any"
                        size="sm"
                        value={row.chart}
                        onChange={e => handleFieldChange(idx, 'chart', e.target.value)}
                        placeholder={idx === 0 ? 'Ex: 123' : idx === 1 ? 'Ex: 4567' : idx === 2 ? 'Ex: -123456' : 'Ex: 12345678'}
                        title={`Envia: CHART${calibOsc === '2' ? '2' : ''}:${row.idx}:valor`}
                        style={{ background: '#1e293b', border: '1px solid #475569', color: '#e2e8f0' }}
                      />
                    ) : (
                      <div className="text-center" style={{ padding: '0.375rem', color: '#64748b' }}>-</div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <Alert variant="warning" className="mt-3 mb-0" style={{ fontSize: '0.85rem', background: 'rgba(251, 191, 36, 0.2)', border: '1px solid rgba(251, 191, 36, 0.3)', color: '#fcd34d' }}>
          <strong>⚠️ Atenção:</strong> Os comandos serão enviados sequencialmente com 200ms de intervalo.<br />
          <div style={{ marginTop: '5px', fontFamily: 'monospace' }}>
            Comandos preenchidos: <strong>{calibTable.filter(r => r.caldial).length}</strong> CALDIAL +
            <strong> {calibTable.filter(r => r.calcapx).length}</strong> CALCAPX +
            <strong> {calibTable.filter((r, i) => i < 4 && r.chart).length}</strong> CHART =
            <strong style={{ color: '#fbbf24' }}> {calibTable.filter(r => r.caldial).length + calibTable.filter(r => r.calcapx).length + calibTable.filter((r, i) => i < 4 && r.chart).length} total</strong>
            <br />
            Tempo estimado: ~{((calibTable.filter(r => r.caldial).length + calibTable.filter(r => r.calcapx).length + calibTable.filter((r, i) => i < 4 && r.chart).length) * 0.2).toFixed(1)}s
          </div>
        </Alert>
      </Modal.Body>
      <Modal.Footer style={{ background: '#0f172a', border: 'none' }}>
        <Button
          variant="outline-secondary"
          onClick={onHide}
          disabled={loading}
        >
          Cancelar
        </Button>
        <Button
          variant="outline-danger"
          onClick={onClear}
          disabled={loading}
        >
          🗑️ Limpar Tudo
        </Button>
        <Button 
          variant="primary" 
          onClick={onSave} 
          disabled={loading || !hasChanges}
          style={{ opacity: (!hasChanges && !loading) ? 0.5 : 1 }}
        >
          {loading ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Salvando...
            </>
          ) : (
            <>💾 Salvar</>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CalibrationTableModal;
